/*
  Puzzle Art product card behaviour for sections whose cards are loaded with AJAX
  (e.g. "You may also like" on the product page).

  Scripts inside HTML that Shopify fetches later do not run, so the inline <script> in
  snippets/card-product.liquid never starts in those sections. This file runs the same
  logic from the page itself.

  Handles the current card markup:
    .pa-size  - A3 / A5 toggle (updates price, compare price and piece count)
    .pa-add   - Add to cart (adds the selected variant and opens the cart drawer)

  If the snippet's own inline script has already started, this file does nothing
  (both use the same window.paCardsInit guard), so nothing is ever added twice.
*/
(function () {
  'use strict';

  if (window.paCardsInit) return;
  window.paCardsInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var size = e.target.closest('.pa-size');
    if (size) {
      if (size.disabled) return;
      var card = size.closest('.pa-card');
      if (!card) return;

      card.querySelectorAll('.pa-size').forEach(function (b) {
        var on = b === size;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var add = card.querySelector('.pa-add');
      if (add) add.dataset.variantId = size.dataset.variantId;

      var now = card.querySelector('.pa-price__now');
      var was = card.querySelector('.pa-price__was');
      if (now) now.textContent = size.dataset.price;
      if (was) {
        was.textContent = size.dataset.compare || '';
        was.hidden = !size.dataset.compare;
      }

      var pieces = card.querySelector('.pa-pieces');
      var dot = card.querySelector('.pa-dot');
      var count = size.dataset.pieces;
      if (pieces) {
        pieces.textContent = count ? count + ' pieces' : '';
        pieces.hidden = !count;
      }
      if (dot) dot.hidden = !count;
      return;
    }

    var btn = e.target.closest('.pa-add');
    if (btn) {
      e.preventDefault();
      addToCart(btn);
    }
  });

  function setLabel(btn, text) {
    var label = btn.querySelector('.pa-add__label');
    if (label) label.textContent = text;
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading')) return;

    var labelEl = btn.querySelector('.pa-add__label');
    var original = labelEl ? labelEl.textContent : 'Add to cart';
    btn.classList.add('is-loading');
    setLabel(btn, 'Adding...');

    function reset(text, delay) {
      setLabel(btn, text);
      setTimeout(function () {
        setLabel(btn, original);
        btn.classList.remove('is-loading');
      }, delay);
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return fetch(root + '?sections=cart-drawer,cart-icon-bubble', {
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: variantId, sections: sections });
          reset('Added ✓', 1200);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        reset('Try again', 1500);
      });
  }
})();